import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { selectSx } from './filterStyles';

/**
 * Select compacto dos filtros do Admin Geral > Novidades.
 * @param {{ value: string, options: Array<{ value: string, label: string }>, onChange: Function }} props
 */
function FilterSelect({ value, options, onChange }) {
  return (
    <Select size="small" value={value} onChange={(e) => onChange(e.target.value)} sx={selectSx} displayEmpty>
      {options.map((opt) => (
        <MenuItem key={opt.value || 'any'} value={opt.value}>{opt.label}</MenuItem>
      ))}
    </Select>
  );
}

export default FilterSelect;
